import VDialog from './VDialog'

export { VDialog }
export default VDialog
